"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createArrayFromTuple = exports.messageBuilder = exports.createArrayFromSerializedTuple = exports.createTupleItems = void 0;
const ton_core_1 = require("ton-core");
const operations_1 = require("./config/operations");
const redstone_constants_1 = require("redstone-protocol/src/common/redstone-constants");
function createTupleItems(items) {
    const tuple = new ton_core_1.TupleBuilder();
    items.forEach((value) => {
        switch (typeof value) {
            case "number":
                tuple.writeNumber(value);
                break;
            case "string":
                tuple.writeNumber(BigInt(value));
                break;
        }
    });
    return tuple.build();
}
exports.createTupleItems = createTupleItems;
function createArrayFromSerializedTuple(cell, value_size_bits = redstone_constants_1.DEFAULT_NUM_VALUE_BS * 8) {
    // TODO: change it to bigint and in other places too.
    let values = [];
    const slice = cell.beginParse();
    while (slice.remainingBits > 0) {
        const value = slice.loadInt(value_size_bits);
        values.push(value);
    }
    while (slice.remainingRefs > 0) {
        const c = slice.loadRef();
        values = values.concat(createArrayFromSerializedTuple(c));
    }
    return values;
}
exports.createArrayFromSerializedTuple = createArrayFromSerializedTuple;
function messageBuilder(opNumber) {
    return (0, ton_core_1.beginCell)().storeUint(opNumber, operations_1.OP_NUMBER_BITS);
}
exports.messageBuilder = messageBuilder;
function createArrayFromTuple(result) {
    const values = [];
    while (result.remaining) {
        values.push(result.readNumber());
    }
    return values;
}
exports.createArrayFromTuple = createArrayFromTuple;
//# sourceMappingURL=ton-utils.js.map